enum AdminMenuTypeStatus {
  processing = 1,
  failed,
  complete,
  aml,
  all
}
export default AdminMenuTypeStatus
